import stl from "./CostumeCheckBox.module.css";
const CostumeCheckBox = ({
  name,
  label,
  className,
  checked,
  onChange,
  src,
  value,
  disabled,
}) => {
  return (
    <label
      className={`${stl.wrapper} ${className ? className : ""} ${
        checked ? stl.checked : ""
      } `}
    >
      <input
        name={name}
        type="checkbox"
        onChange={onChange}
        checked={checked}
        value={value}
        disabled={disabled}
      />
      {src && checked && <img src={src} alt="whatsapp" />}
      <span/>
      {label}
    </label>
  );
};
export default CostumeCheckBox;
